import { Button } from "@memento/ui/Button";
import Link from "next/link";

export type AddReactionVideoProps = {
  addReactionUrl: string;
};

export const AddReactionVideo = ({ addReactionUrl }: AddReactionVideoProps) => {
  return (
    <div className="mx-auto mt-8 flex flex-col items-center justify-center rounded-2xl bg-white p-6 shadow-lg sm:flex-row sm:justify-between lg:w-2/3">
      <div className="flex flex-col items-center sm:flex-row">
        <div>
          <div className="h-20 w-20 rounded-full bg-red-500 p-4">
            <img src="/images/icons/icnClap.svg" alt="clap" />
          </div>
        </div>
        <div className="mr-4 flex flex-col text-center sm:mx-4 sm:text-left">
          <div className="text-lg">Say Thanks!</div>
          <div className="mt-2 text-sm">
            Record or upload a thank you video the organizer can share with
            group video contributors
          </div>
        </div>
      </div>
      <Link href={addReactionUrl}>
        <Button variant="inverse" size="lg" className="mt-4 text-sm sm:mt-0">
          Add Video
        </Button>
      </Link>
    </div>
  );
};
